import { IQuestionAnswer } from '../../form-root/contracts';

export type CreatePersonAnswerSelections = {
	contacts: Array<Record<string, string | boolean>>;
	businessDetails?: { businessName?: string; businessAddress?: string };
};

export const updateAnswerForContact = (
	currentAnswer: IQuestionAnswer,
	currentAnswerSelections: CreatePersonAnswerSelections,
	contactId: string,
	answerQuestion: (answer: IQuestionAnswer, isAnswered?: boolean) => void,
	properyToUpdate: string,
	value: string | boolean, // This type is incorrect
	questionType: string
) => {
	if (contactId) {
		const answer = currentAnswerSelections?.contacts?.find(a => a.id === contactId);
		if (answer) {
			answer[properyToUpdate] = value;
			answerQuestion({
				...currentAnswer,
				answer: {
					answerJson: JSON.stringify({
						...currentAnswerSelections
					})
				},
				type: questionType
			});
		}
	}
};

export const updateAnswerForAllContacts = (
	currentAnswer: IQuestionAnswer,
	currentAnswerSelections: CreatePersonAnswerSelections,
	answerQuestion: (answer: IQuestionAnswer, isAnswered?: boolean) => void,
	propertyToUpdate: string,
	value: string | boolean,
	questionType: string
) => {
	currentAnswerSelections['contacts'] =
		currentAnswerSelections?.contacts?.map(c => ({
			...c,
			[propertyToUpdate]: value ?? ''
		})) ?? [];

	answerQuestion({
		...currentAnswer,
		answer: {
			answerJson: JSON.stringify({
				...currentAnswerSelections
			})
		},
		type: questionType
	});
};

export const updateBusinessDetailsForContact = (
	currentAnswer: IQuestionAnswer,
	currentAnswerSelections: CreatePersonAnswerSelections,
	contactId: string,
	answerQuestion: (answer: IQuestionAnswer, isAnswered?: boolean) => void,
	update: Record<string, string | boolean>,
	questionType: string
) => {
	if (contactId) {
		answerQuestion({
			...currentAnswer,
			answer: {
				answerJson: JSON.stringify({
					...currentAnswerSelections,
					contacts: currentAnswerSelections?.contacts?.map(f => (f.id === contactId ? { ...f, ...update } : f))
				})
			},
			type: questionType
		});
	}
};

export const updateBusinessDetailsForAllContacts = (
	currentAnswer: IQuestionAnswer,
	currentAnswerSelections: CreatePersonAnswerSelections,
	answerQuestion: (answer: IQuestionAnswer, isAnswered?: boolean) => void,
	propertiesToUpdate: Array<string>,
	values: Array<string | boolean>,
	allContactsFromBusiness: boolean,
	updateForBusiness: boolean,
	questionType: string
) => {
	if (!currentAnswerSelections?.businessDetails) {
		currentAnswerSelections['businessDetails'] = {};
	}

	if (allContactsFromBusiness !== undefined) {
		currentAnswerSelections.businessDetails['allContactsFromBusiness'] = allContactsFromBusiness;
	}

	propertiesToUpdate.forEach((p, i) => {
		if (!currentAnswerSelections.businessDetails) {
			currentAnswerSelections.businessDetails = {};
		}
		if (updateForBusiness) {
			currentAnswerSelections.businessDetails[p] = values[i];
		}
		if (allContactsFromBusiness === true) {
			currentAnswerSelections['contacts'] =
				currentAnswerSelections?.contacts?.map(c => {
					return {
						...c,
						[p]: currentAnswerSelections.businessDetails![p] ?? ''
					};
				}) ?? [];
		} else {
			currentAnswerSelections['contacts'] =
				currentAnswerSelections?.contacts?.map(c => {
					const index = propertiesToUpdate.findIndex(p => p === 'asAbove');
					const asAboveInput = values[index];
					if (index > -1 ? c.asAbove === true && asAboveInput === true : c.asAbove === true) {
						return {
							...c,
							[p]: currentAnswerSelections.businessDetails![p] ?? ''
						};
					} else if (asAboveInput === false) {
						return { ...c, [p]: values[i] };
					} else {
						return c;
					}
				}) ?? [];
		}
	});

	answerQuestion({
		...currentAnswer,
		answer: {
			answerJson: JSON.stringify({
				...currentAnswerSelections
			})
		},
		type: questionType
	});
};

export function getBusinessAddresses(businessDetails: Record<string, unknown>) {
	return Object.fromEntries(Object.entries(businessDetails).filter(([key, val]) => key.startsWith('businessAddress')));
}
